import { LocalizedText } from '@mews/framework';
import { TextKey } from '@mews-commander/enums';
import { CompanyOptions } from '@mews-commander/data-access';
import { areInvoicesTaxDeductable } from '@mews-commander/legacy-entities/src/ducks/companies';
import { useCommanderSelector } from '@mews-commander/utils';
import { EnumSelectField, NumberInputField } from '@mews-commander/legacy-form';

const optionsProps = {
    name: 'options',
    label: <LocalizedText textKey={TextKey.Options} />,
    multiselect: true,
    enumClass: CompanyOptions,
    enumPrefix: 'CompanyOptions',
} as const;

const invoiceDueIntervalProps = {
    label: <LocalizedText textKey={TextKey.InvoiceDueInterval} />,
    name: 'invoiceDueInterval',
    suffix: <LocalizedText textKey={TextKey.Days} />,
    min: 0,
    max: 365,
};

export const CompanyPaymentFields = () => {
    const allowTaxDeductions = useCommanderSelector((state) => areInvoicesTaxDeductable(state, {}));
    const companyPaymentOptions = [CompanyOptions.AddFeesToInvoices, CompanyOptions.Invoiceable];
    if (allowTaxDeductions) {
        companyPaymentOptions.push(CompanyOptions.AddTaxDeductedPaymentToInvoices);
    }
    return (
        <>
            <NumberInputField {...invoiceDueIntervalProps} />
            <EnumSelectField {...optionsProps} enabledValues={companyPaymentOptions} />
        </>
    );
};
